import type { DocumentRepository } from "../repositories/document-repository"

export const makeRetryDocument = (repo: DocumentRepository) =>
  (docId: string) =>
    repo.retry(docId)
